<h2 mat-dialog-title class="modal-title">{{ data.name }}</h2>

<mat-dialog-content class="modal-content">
  <div class="image-container">
    <div class="loading-placeholder" *ngIf="!isImageLoaded && !hasError">
      <mat-spinner diameter="40" strokeWidth="3" color="accent"></mat-spinner>
    </div>

    <div class="error-state" *ngIf="hasError">
      <p>Could not load the image. The preview link may have expired.</p>
    </div>

    <img
      *ngIf="!hasError"
      [src]="data.url"
      [alt]="data.name"
      class="preview-image"
      [class.hidden]="!isImageLoaded"
      (load)="onImageLoad()"
      (error)="onImageError()"
    />
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-actions">
  <button mat-stroked-button (click)="close()">Close</button>
</mat-dialog-actions>
